import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {NutritionAssignment} from '@emm/core/models/nutrition.model';
import {standardRetry} from '@emm/core/util/rx.util';


@Injectable({ providedIn: 'root' })
export class NutritionService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) { }



    public getProfileAssignments(location: string): Observable<NutritionAssignment[]> {
        return this.http
            .get<any>(`${this.apiUrl}/nutrition/profile/assignments/${location}`)
            .pipe(
                map((response: any) => {
                    response.effectiveDateNutritionProfileDtos.map(item => {
                        return item.effectiveDate = this.toTime(item.effectiveDate)
                    });
                    return response.effectiveDateNutritionProfileDtos;
                }),
                standardRetry()
            );
    }



    public getProfileOptions(): Observable<number[]> {
        return this.http
            .get<any>(`${this.apiUrl}/nutrition/profiles`)
            .pipe(
                map((response: any) => {
                    return Array.isArray(response) && response.length ? response : [1];
                }),
                standardRetry()
            );
    }



    public saveLocationAssignment({ dateShort, location, profile }): Observable<void> {
        const payload = {
            profile: profile,
            effectiveDate: dateShort
        };
        return this.http
            .put<any>(`${this.apiUrl}/nutrition/profile/assignments/${location}`, payload)
            .pipe(
                map((response: any) => response),
                standardRetry()
            );
    }



    toTime(effectiveDate: string): number {
        const [year, month, date] = effectiveDate.split('-');
        return new Date(+year, +month - 1, +date).getTime();
    }



}
